import { Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import React from "react";
import { VscEmptyWindow } from "react-icons/vsc";
import { useSelector } from "react-redux";
import "./customer.css";

function CustomerDetailsTable() {
  const customer = useSelector((state) => state.customer.customer);
  const id = customer.id || "";

  const isLoading = useSelector((state) => state.customer.isLoading);

  // let customerOrderHistory = []
  // if (customer?.shirtorders && customer?.shirtorders.length > 0) {
  //     customerOrderHistory = [...customerOrderHistory, ...customer?.shirtorders]
  // }
  // if (customer?.pantorders && customer?.pantorders.length > 0) {
  //     customerOrderHistory = [...customerOrderHistory, ...customer?.pantorders]
  // }

  const shirtData = [
    {
      title: "उंची",
      value: customer?.shirt?.height,
      dataIndex: "shirtheight",
    },
    {
      title: "छाती",
      value: customer?.shirt?.chest,
      dataIndex: "shirtchest",
    },
    {
      title: "पोट",
      value: customer?.shirt?.stomach,
      dataIndex: "shirtstomach",
    },
    {
      title: "सीट",
      value: customer?.shirt?.seat,
      dataIndex: "shirtseat",
    },
    {
      title: "फ्रंट",
      value: customer?.shirt?.front,
      dataIndex: "shirtfront",
    },
    {
      title: "पोट",
      value: customer?.shirt?.pot,
      dataIndex: "shirtpot",
    },
    {
      title: "शोल्डर",
      value: customer?.shirt?.shoulder,
      dataIndex: "shirtshoulder",
    },
    {
      title: "भाई",
      value: customer?.shirt?.bhai,
      dataIndex: "shirtbhai",
    },
    {
      title: "कप",
      value: customer?.shirt?.cup,
      dataIndex: "shirtcup",
    },
    {
      title: "गळा",
      value: customer?.shirt?.throat,
      dataIndex: "shirtthroat",
    },
    {
      title: "बॅग",
      value: customer?.shirt?.bag,
      dataIndex: "shirtbag",
    },
    {
      title: "भाई लूझिंग",
      value: customer?.shirt?.bhailoosing,
      dataIndex: "shirtbhailoosing",
    },
  ];
  const pantData = [
    {
      title: "उंची",
      value: customer?.pant?.height,
      dataIndex: "pantheight",
    },
    {
      title: "कंबर",
      value: customer?.pant?.kambar,
      dataIndex: "pantkambar",
    },
    {
      title: "सीट",
      value: customer?.pant?.seat,
      dataIndex: "pantseat",
    },
    {
      title: "मांडी",
      value: customer?.pant?.mandi,
      dataIndex: "pantmandi",
    },
    {
      title: "गुडगा",
      value: customer?.pant?.gudga,
      dataIndex: "antgudga",
    },
    {
      title: "बॉटम",
      value: customer?.pant?.bottom,
      dataIndex: "pantbottom",
    },
  ];
  const data = [
    {
      title: "नाव",
      value: customer?.name,
      dataIndex: "Name",
    },
    {
      title: "दूरध्वनी क्रमांक",
      value: customer?.phonenumber,
      dataIndex: "Phonenumber",
    },
    {
      title: "पत्ता",
      value: customer?.address,
      dataIndex: "Address",
    },
  ];
  console.log("customer", customer);
  // const handleDelete = async (id) => {
  //     try {
  //         if (customer.orders.length !== 0) {
  //             return Notification(customer.Name, "यांची मागणी अपूर्ण आहे.", "error");
  //         } else {
  //             await dispatch(deleteCustomer(id));
  //             history.push("/customers");
  //             return;
  //         }
  //     } catch (err) {
  //         const errorMessage =
  //             (err?.response && err?.response?.data?.message) ||
  //             "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
  //         Notification("", errorMessage, "error");
  //     }
  // };
  const fontWeightCustom = "bold";
  const fontSizeCustom = "20px";
  return isLoading ? (
    <Flex h="70vh" justify="center" align="center" direction="column">
      <Spinner></Spinner>
    </Flex>
  ) : (
    [
      id !== "" ? (
        <Flex minH="70vh" w="80%" marginX="auto" direction="column" key="1">
          <Heading textAlign="center" my={"10"} fontWeight="bold">
            ग्राहक तपशील
          </Heading>
          <Flex
            direction="column"
            border="1px"
            borderColor="gray.200"
            borderRadius="10px"
            p={5}
          >
            <Heading fontWeight="bold" mx="2">
              ग्राहकाची माहिती :
            </Heading>
            <Flex
              direction="row"
              align="center"
              w="100%"
              overflowX="scroll"
              flexWrap="wrap"
            >
              {data.map((data, index) => {
                return (
                  <Flex
                    display="inline-flex"
                    key={index}
                    border="1px solid black"
                    px="2"
                    m="2"
                  >
                    <Text mr="5" fontSize="28px">
                      {data.title} :{" "}
                    </Text>
                    <Text ml="5" fontSize="28px" fontWeight="bold">
                      {data.value}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
            <Heading fontWeight="bold" mx="2">
              ग्राहकाची पँट साईज :
            </Heading>
            <Flex
              direction="row"
              align="center"
              w="100%"
              overflowX="scroll"
              flexWrap="wrap"
            >
              {pantData.map((data, index) => {
                return (
                  <Flex
                    display="inline-flex"
                    key={index}
                    border="1px solid black"
                    px="2"
                    m="2"
                  >
                    <Text mr="5" fontSize="28px">
                      {data.title} :{" "}
                    </Text>
                    <Text ml="5" fontSize="28px" fontWeight="bold">
                      {data.value}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
            <Heading fontWeight="bold" mx="2">
              ग्राहकाची शर्ट साईज :
            </Heading>
            <Flex
              direction="row"
              align="center"
              w="100%"
              overflowX="scroll"
              flexWrap="wrap"
            >
              {shirtData.map((data, index) => {
                return (
                  <Flex
                    display="inline-flex"
                    key={index}
                    border="1px solid black"
                    px="2"
                    m="2"
                  >
                    <Text mr="5" fontSize="28px">
                      {data.title} :{" "}
                    </Text>
                    <Text ml="5" fontSize="28px" fontWeight="bold">
                      {data.value}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
          </Flex>

          <Flex
            direction="column"
            border="1px"
            borderColor="gray.200"
            borderRadius="10px"
            borderTopRadius="0px"
            p="5"
          >
            <Heading my="2" textAlign="center">
              ग्राहक मागणी
            </Heading>

            {customer?.mainorders?.map((data, index) => {
              return (
                <Flex boxShadow="dark-lg" m="5" direction="column" key={index}>
                  <Flex bg={data?.isActive === false ? "#00CA00" : "#FF033E"}>
                    <Text
                      fontSize="20px"
                      p="5"
                      fontWeight="900"
                      color="blackAlpha.900"
                    >
                      मागणी क्रमांक : {data?.id}
                    </Text>
                    <Text
                      fontSize="20px"
                      p="5"
                      fontWeight="900"
                      color="blackAlpha.900"
                    >
                      मागणी दिनांक : {data?.published_at?.slice(0, 10)}
                    </Text>
                  </Flex>

                  <Flex flexWrap="wrap" m="5">
                    <Text
                      mx="2"
                      fontWeight={fontWeightCustom}
                      fontSize={fontSizeCustom}
                    >
                      किंमत : {data?.price}
                    </Text>
                    <Text
                      mx="2"
                      fontWeight={fontWeightCustom}
                      fontSize={fontSizeCustom}
                    >
                      आगाऊ रोख किंमत : {data?.advance}
                    </Text>
                    <Text
                      mx="2"
                      fontWeight={fontWeightCustom}
                      fontSize={fontSizeCustom}
                    >
                      शिल्लक रोख किंमत : {data?.balance}
                    </Text>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      ) : (
        <Flex
          h="70vh"
          justify="center"
          align="center"
          direction="column"
          key="2"
        >
          <VscEmptyWindow size="48px" />
          <Text fontWeight="bold">Not Found</Text>
        </Flex>
      ),
    ]
  );
}

export default CustomerDetailsTable;
